
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import { getProductDetail, sumbitOrder } from '@/api/youzheng.js'
import { getAddressDefault, getintegral } from '@/api/user.js'
import { getSelfAddress } from '@/api/sys.js'
import Storage from '@/storage'
import errorImg from '@/assets/mall/img-error.png'
import config from '@/config/index'
import addressedit from '@/views/address-select'
export default {
name: 'sumbitorder',
directives: {
TransferDom
},
data () {
return {
id: this.$route.params.id,
goodsObj: {},
baseUrl: config.baseUrl,
errorImg: errorImg,
score: 0,
num: 1,
addressObj: {},
openid: Storage.get('openId'),
owner_type: config.owner_type,
integral: '',
deliveryList: [{
name: '自提',
value: '1'
}, {
name: '快递',
value: '2'
}],
delivery: ['2'],
selfAddress: '',
maxnum: 0,
isColor: ['#db2111', '#ec653c'],
openAddress: false,
message: ''
}
},
components: {
Cell,
Group,
Flexbox,
FlexboxItem,
XNumber,
XTextarea,
XButton,
PopupRadio,
PopupPicker,
Popup,
addressedit
},
created () {
this.getAddress()
this.getDetail()
this.getintegralTotal()
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
activated () {
console.log(22)
if (this.$store.state.user.address.ID !== '') {
this.openAddress = true

}
},
watch: {
num (val) {
if (val < 1 && val !== '') {
this.$vux.toast.text('受不了了，宝贝不能再减少了哦', 'middle')
} else if (this.goodsObj.LIMITNUM == 0 && val >= this.goodsObj.AMOUNT) {
this.$vux.toast.text('该商品最多只能购买' + this.goodsObj.AMOUNT + '件', 'middle')
} else if (this.goodsObj.LIMITNUM >= this.goodsObj.AMOUNT && this.goodsObj.LIMITNUM != 0) {
this.$vux.toast.text('该商品最多只能购买' + this.goodsObj.AMOUNT + '件', 'middle')
} else if (this.goodsObj.LIMITNUM < this.goodsObj.AMOUNT && this.goodsObj.LIMITNUM != 0) {
this.$vux.toast.text('该商品最多只能购买' + this.goodsObj.LIMITNUM + '件', 'middle')
}
this.score = this.goodsObj.CREDIT * val
},
delivery: {
handler (val) {
if (val == 1) {
this.getlift()
}
},
deep: true
}
},
methods: {
getintegralTotal () {
getintegral({
accountid: this.accountid,
userid: this.userid,
owner_type: this.owner_type
}).then(res => {
this.integral = res.returnValue.allnow
})
},
getAddress () {
getAddressDefault({
accountid: this.accountid,
userid: this.userid
}).then(res => {
if (res.returnValue != '') {
this.addressObj = res.returnValue
}
})
},
getDetail () {
getProductDetail({
productid: this.id
}).then(res => {
this.goodsObj = res.returnValue
this.score = this.goodsObj.CREDIT * this.num
if (this.goodsObj.LIMITNUM !== 0) {
if (this.goodsObj.AMOUNT <= this.goodsObj.LIMITNUM) {
this.maxnum = this.goodsObj.AMOUNT
} else {
this.maxnum = this.goodsObj.LIMITNUM
}
} else {
this.maxnum = this.goodsObj.AMOUNT
}
})
},
onImgError ($event) {
$event.target.src = this.errorImg
},
sumbit () {
if (JSON.stringify(this.addressObj) !== '{}') {
if (this.num > 0) {
sumbitOrder({
productid: this.id,
accountid: this.accountid,
addressid: this.addressObj.ID,
ordercredit: this.score,
ordertype: 1,
insertsource: 1,
productnum: this.num,
userid: this.userid,
ispickbyself: parseInt(this.delivery[0]),
note: this.message
}).then(res => {
var that = this
this.integral = this.integral - this.score
this.$vux.alert.show({
title: '兑换成功！',
content: '已扣除' + this.score + '积分，当前您剩余<span style="color:red">' + this.integral + '</span>积分',
buttonText: '返回我的订单',
onShow () { },
onHide () {
that.$router.push({ name: 'mallOrderlist' })
}
})
})
} else {
this.$vux.toast.text('请选择兑换数量', 'middle')
}
} else {
this.$vux.toast.text('请选择收货地址', 'middle')
}
},

getlift () {
getSelfAddress().then(res => {
if (res.obj && res.obj.length > 0) {
this.selfAddress = res.obj[1].value
}
})
},
openPopup () {
this.openAddress = true

},
changeAddress (isdisplay) {
if (isdisplay === 'false') {
this.openAddress = false
this.addressObj = this.$store.state.user.address
}
}
},
beforeRouteEnter (to, from, next) {
next(vm => {
if (from.name === 'addressAdd') {
vm.openAddress = true
}
})
}
}
